export enum RestrictPeriod {
  Day = 1,
  Week = 2,
  Month = 3,
}
